// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";

export default class MapFilterCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    withSlug(slug) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.slug == slug );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    withFilterCode(filterCode) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.code == filterCode );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    // The default map filter is the first item in the collection.
    defaultMapFilter() {
        if (this.isEmpty()) return null;
        return this[0];
    }

}